// Mocked field generators for Users page values that depend on backend
// work not yet shipped. Each function is deterministic per user id so the
// page doesn't reshuffle on re-render. Visible markers (see MockedValue.tsx)
// make it obvious in the UI that the data is fake — these markers should
// disappear when the corresponding backend work lands.
//
// Backend follow-ups tracked:
//   • lastActive  — needs UserSession tracking or Auth0 `last_login` field
//   • auth0Sub    — already on User row, just needs to be returned by /api/v1/staff
//   • activeSessions KPI — needs UserSession aggregate (last-hour bucket)

const LAST_ACTIVE_POOL = [
  '3m ago',
  '12m ago',
  '22m ago',
  '40m ago',
  '1h ago',
  '2h ago',
  '4h ago',
  '6h ago',
  'yesterday',
  '1d ago',
  '4d ago',
];

function hash(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i += 1) {
    h = (h * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function mockedLastActive(userId: string): string {
  return LAST_ACTIVE_POOL[hash(userId) % LAST_ACTIVE_POOL.length];
}

export function mockedAuth0Sub(userId: string): string {
  // Deterministic 7-digit suffix so the value looks Auth0-shaped.
  const n = (hash(userId) % 9_000_000) + 1_000_000;
  return `auth0|${n}`;
}

/** Top-of-page KPI mocks. Returned together so a future swap to a real
 *  endpoint replaces one call. */
export const MOCKED_KPIS = {
  activeSessions: 18,
};
